import ArcMosaicoLogoSrc from 'assets/arcmosaico/arcmosaico-logo.svg'

const DEFAULT_LOGO_HEIGHT_PX = 32

interface ArcLogoProps {
  readonly height?: number
}

/**
 * ArcMosaico horizontal lockup (mark + wordmark outlined, no font dependency).
 * Brand spec: AR-792 — asset extracted from https://arcmosaico.ai/
 */
export const ArcLogo = ({ height = DEFAULT_LOGO_HEIGHT_PX }: ArcLogoProps) => (
  <img src={ArcMosaicoLogoSrc} alt='ArcMosaico' height={height} style={{ display: 'block' }} />
)
